import moment from "moment";

export const dateFomatYMD = (dateObject) => {
    const isoString = dateObject.toISOString();
    return isoString.split("T")[0];

}

  export const convertPeriodToDate = (period) => {
    let from = "";
    let to = moment().format("YYYY-MM-DD");

    switch (period) {
      case "today":
        from = to;
        break;
      case "yesterday":
        from = moment().subtract(1, "days").format("YYYY-MM-DD");
        to = from;
        break;
      case "last_7_days":
        from = moment().subtract(7, "days").format("YYYY-MM-DD");
        break;
      case "last_15_days":
        from = moment().subtract(15, "days").format("YYYY-MM-DD");
        break;
      case "last_30_days":
        from = moment().subtract(30, "days").format("YYYY-MM-DD");
        break;
      case "this_month":
        from = moment().startOf("month").format("YYYY-MM-DD");
        break;
      case "last_month":
        from = moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD");
        to = moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD");
        break;
      case "last_3_months":
        from = moment().subtract(3, "months").format("YYYY-MM-DD");
        break;
      case "this_year":
        from = moment().startOf("year").format("YYYY-MM-DD");
        break;
      default:
        from = "";
        to = "";
    }
    return {from, to}
  };
